angular.module('cian.serp.item')
.controller('MenuCtrl', ["$scope", "close", "UserService", function ($scope, close, UserService) {
  $scope.close = function() {
    close(true);
  };

  $scope.favoriteText = function() {
    return $scope.offer.favorite.state?'Убрать из избранного':'В избранное';
  };

  $scope.premiumText = function() {
    return $scope.offer.premium.state?'Отменить премиум':'Купить премиум';
  };

  $scope.mapText = function () {
    return $scope.isMapOpen?'Скрыть карту':'Показать на карте';
  }
}]);


//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.menu.js
// module id = 496
// module chunks = 0